<template>
  <div id="publishing-eference-add">
    <ipub-model :title="params.id?'Edit Funding':'Add Funding'"
                width="700px"
                :visable="isVisable"
                :confirmText="params.id?'Save':'Add'"
                @confirm="confirm"
                @cancel="cancel">
      <ipub-form ref="reference-add-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item prop="name"
                        label="Funder">
          <ipub-input placeholder="Funder"
                      :select="founds"
                      @input="getFound"
                      @select="onFoundationChange"
                      optionKey="name"
                      v-model.trim="params.name" />
        </ipub-form-item>
        <ipub-form-item prop="code"
                        label="Grant Number">
          <ipub-input placeholder="Grant Number"
                      v-model.trim="params.code" />
        </ipub-form-item>
      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import article from '../../../../api/article'
import help from '../../../../utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      params: {
        name: '',
        code: ''
      },
      rules: {},
      founds: [],
      getFound: ''
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          name: '',
          code: ''
        }
      } else {
        this.params = Object.assign(this.params, this.inputData)
      }
    }
  },
  mounted () {
    this.getRules()
    this.getFound = help.debounce(async () => {
      this.founds = await article.getFound(this.params.name)
    }, 1000)
    this.getFound()
  },
  methods: {
    onFoundationChange (val) {
      // this.params.code = val.code
    },
    async confirm () {
      const flag = this.$refs['reference-add-form'].validate()
      if (flag) {
        this.$message.success({ title: 'Success', content: 'This Funding has been saved!' })
        this.$emit('confirm', this.params)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        name: [
          {
            required: true,
            message:
              'Funder Name' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 1024,
            message: `Funder Number cannot be more than 200 digits`
          },
        ],
        code: [
          // {
          //   required: true,
          //   message:
          //     'Grant Number' +
          //     this.LANGUAGE[this.language].noEmpty,
          // },
          {
            max: 1024,
            message: `Grant Number cannot be more than 100 digits`
          },
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
